import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  loanOfficersBox: {
    position: 'relative',
    height: '100%',
    maxWidth: 470,
    minWidth: 370,
    borderRight: `1px solid ${theme.palette.colors.border}`,
  },
  rightBar: {
    position: 'relative',
    height: '100%',
    minWidth: 470,
    maxWidth: 470,
    borderLeft: `1px solid ${theme.palette.colors.border}`,
  },
  chatBox: {
    minWidth: 500,
    width: '100%',
  },
  chatPlaceholder: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerMessages/components/DesktopMessages/useStyles.js